export const formatPrice = (price: number | bigint, decSpaces = 2) => {
  const currency = localStorage.getItem('currencyCode') ?? 'EUR';
  return new Intl.NumberFormat('bs-BA', {
    style: 'currency',
    currency,
    minimumFractionDigits: decSpaces,
    maximumFractionDigits: decSpaces,
  }).format(price ?? 0);
};
